<template>
  <v-dialog v-model="dialog" scrollable width="750">
    <v-card>
      <v-toolbar color="primary" dense class="elevation-0" dark>
        <v-toolbar-title>Thêm mới thiết bị / tài sản</v-toolbar-title>
        <v-spacer />
        <v-btn icon dark @click="cancel">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pt-4">
        <AssetForm ref="assetForm" :assetData="assetData" />
      </v-card-text>
      <v-divider />
      <v-card-actions class="pa-4">
        <v-btn outlined @click="cancel">HUỶ</v-btn>
        <v-spacer />
        <v-btn color="primary" @click="save">LƯU</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import AssetForm from '@/modules/facility/asset/AssetForm.vue'
import { mapActions } from 'vuex'

export default {
  name: 'AssetNewDialog',
  components: { AssetForm },
  props: {
    state: Boolean
  },
  data() {
    return {
      dialog: false,
      assetData: {}
    }
  },
  watch: {
    state(val) {
      if (val) {
        this.dialog = true
        this.assetData = {}
      }
    }
  },
  methods: {
    ...mapActions('FacilityAssets', ['createAsset']),
    cancel() {
      this.dialog = false
      this.assetData = {}
      if (this.$refs.assetForm) {
        this.$refs.assetForm.resetValidation()
      }
    },
    async save() {
      if (!this.$refs.assetForm.validate()) return

      this.$loading.active = true
      try {
        const payload = this.$refs.assetForm.getData()
        delete payload.id
        await this.createAsset(payload)
        this.dialog = false
        this.$emit('updated')
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    }
  }
}
</script>
